var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrickEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 70,
    viewBox: "0 0 72 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_14748_23718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0996 68.51L70.9996 46.02V17.52L19.0996 38.34V68.51Z",
    fill: "#E4E4E4",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 54.41L19.1 68.53V38.34L1 24.75V54.41Z",
    fill: "#E4E4E4",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 17.5201L19.1 38.3401L1 24.7501L51.64 3.3501L71 17.5201Z",
    fill: "#E4E4E4",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3796 17.9403C32.3796 14.9203 28.0596 12.3903 22.7196 12.3003C17.3796 12.2103 13.0596 14.5803 13.0596 17.6103C13.0596 17.6503 13.0596 17.6803 13.0596 17.7203V23.7503H13.1096C13.5996 26.5203 17.7196 28.7503 22.7196 28.8403C27.7196 28.9303 31.8296 26.8403 32.3296 24.0903H32.3796V18.0603C32.3796 18.0603 32.3796 17.9903 32.3796 17.9503V17.9403Z",
    fill: "#E4E4E4",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1403 7.56045C60.1403 4.54045 55.8203 2.01045 50.4803 1.92045C45.1403 1.83045 40.8203 4.20045 40.8203 7.23045C40.8203 7.27045 40.8203 7.30045 40.8203 7.34045V13.3704H40.8703C41.3603 16.1404 45.4803 18.3704 50.4803 18.4604C55.4803 18.5504 59.5903 16.4604 60.0903 13.7104H60.1403V7.68045C60.1403 7.68045 60.1403 7.61045 60.1403 7.57045V7.56045Z",
    fill: "#E4E4E4",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3798 17.5318C32.4562 14.5339 28.1946 11.9934 22.8613 11.8574C17.528 11.7215 13.1425 14.0416 13.0661 17.0395C12.9897 20.0375 17.2513 22.578 22.5846 22.7139C27.9179 22.8498 32.3034 20.5297 32.3798 17.5318Z",
    fill: "#E4E4E4",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1308 7.15679C60.2072 4.15886 55.9456 1.61836 50.6123 1.48243C45.2789 1.34649 40.8935 3.6666 40.8171 6.66454C40.7407 9.66247 45.0022 12.203 50.3356 12.3389C55.6689 12.4748 60.0544 10.1547 60.1308 7.15679Z",
    fill: "#E4E4E4",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14748_23718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 69.06,
    fill: "white",
    transform: "translate(0 0.470215)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrickEmptyState);
export default __webpack_public_path__ + "static/media/brick_empty_state.353713d73a083e818a73a9a7eda105b4.svg";
export { ForwardRef as ReactComponent };